<template>
  <div class="m-timeline-area" :style="`width: ${width}px`">
    <div class="m-timeline">
      <div
        :class="['m-timeline-item', { last: index === timelineDesc.length - 1 }]"
        v-for="(item, index) in timelineDesc"
        :key="index"
      >
        <div class="u-tail"></div>
        <div class="u-dot"></div>
        <div class="u-title">{{ item.updateDate }}</div>
           <div class="u-content" v-if="index == timelineDesc.length - 1">
         申请人：{{ item.wecharUser_dictText || '--' }}
        </div>
        <div v-else class="u-content">处理人：{{ item.updateUser_dictText || '--'}}</div>
        <div class="u-content">处理方式：{{ item.flowAction_dictText || '--' }}</div>
        <div class="u-content">处理内容：{{ item.comments || '--' }}</div>
       
        <div class="imgList" v-if="item.imgList">
          <div class="pre-item" v-for="(img, index) in item.imgList" :key="index">
            <img class="pre-item-image" :src="img" @click.stop="preImage(index, item.imgList)" />
          </div>
        </div>
        <div class="video" v-if="item.videoList" style="margin-top: 12px">
          <div class="video-item" v-for="(v, index) in item.videoList" :key="index">
            <video :src="v" controls="controls" style="width: 100%; height: 180px"></video>
          </div>
        </div>
        <div  class="u-content" style="margin-top: 10px">下一步处理人：{{ index==0?currName:timelineDesc[index-1].updateUser_dictText}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
export default {
  props: {
    timelineDesc: {
      // 时间轴内容数组
      type: Array,
      default: () => {
        return []
      },
    },
    currName:{
      type: String,
      default: '',
    },
    width: {
      // 时间轴区域总宽度
      type: Number,
      default: 360,
    },
  },
  methods: {
    preImage(index, imgList) {
      ImagePreview({
        images: imgList,
        startPosition: index,
      })
    },
  },
}
</script>
<style lang="less" scoped>
@blue: #1890ff;
@green: #52c41a;
@red: #f5222d;
@gray: rgba(0, 0, 0, 0.25);
.m-timeline-area {
  margin: 0 auto;
  .m-timeline {
    .m-timeline-item {
      position: relative;
      padding-bottom: 20px;
      .u-tail {
        position: absolute;
        top: 10px;
        left: 5px;
        height: calc(100% - 10px);
        border-left: 2px solid #e8e8e8; // 实线
        // border-left: 2px dotted #e8e8e8; // 点线
        // border-left: 2px dashed #e8e8e8; // 虚线
      }
      .u-dot {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid @blue;
        border-radius: 50%;
      }
      .u-content {
        position: relative;
        top: -6px;
        margin-left: 30px;
        word-break: break-all;
        word-wrap: break-word;
        line-height: 24px;
        font-size: 14px;
        width: 80%;
      }
      .u-createTime {
        color: #696969;
        font-size: 13px;
        margin-left: 30px;
      }

      .u-title {
        font-size: 16px;
        color: #000;
        position: relative;
        top: -6px;
        margin-left: 30px;
        margin-bottom: 10px;
      }
    }
    .last {
      .u-tail {
        display: none;
      }
    }
  }
}

.pre-item {
  border-radius: 5px;
  height: 80px;
  overflow: hidden;
  position: relative;
}

.pre-item-image {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 8px;
}

.imgList {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0 0 12px;
}

.video-item {
  background: #000;
  width: 80%;
}
</style>